const { toPairs } = require('lodash');

require('./bootstrap');
// Register $ global var for jQuery
// 
window.$ = window.jQuery = require('jquery');


//window.Popper = require('popper.js').default; // pay attention to "default"
require('bootstrap-v4-rtl/dist/js/bootstrap');

require('tablesorter/dist/js/jquery.tablesorter');
require('tablesorter/dist/js/widgets/widget-filter.min');
require('tablesorter/dist/js/parsers/parser-input-select.min');
require('tablesorter/dist/js/widgets/widget-grouping.min');

smartmenus = require("smartmenus");
var FileSaver = require( 'file-saver' );
toBlob = require('canvas-to-blob');
html2canvas = require('html2canvas');


d3 = require("d3");
lazyload = require("lazyload");
window.enquire  = require( "enquire.js");




//enquire = require("enquire.js");
TrendChart = require('./charts/trend').default;
QuestionPieChart = require('./charts/questionPie').default;


/*
import $ from 'jquery';
window.$ = window.jQuery = $;
*/
$( document ).ready(function() {
    //console.log( "ready!" );
    //alert( "ready!" );
    

    $('div.alert').not('.alert-important').delay(3000).slideUp(350);


    $(".btn-confirm").click(function(event) {


        if( !confirm($(this).data('confirm-message')) ) 
        {
            event.preventDefault();
        }
    });

    //smartmenu init
    $('.smartmenu').smartmenus({
        subIndicators: true,
        subIndicatorsPos: "append",
        subIndicatorsText: ""
    });

    if ( $( ".structure-menu" ).length ) {
        //then we call ajax to re-pop with full menu
        $( ".structure-menu" ).each(function( index ) {
            var menu = $( this );
            var url = menu.attr('data-url');

            //alert( url );

            $.ajax({
                method: "GET",
                url: url,
            })
            .done(function( result ) {
             

                menu.html( result );
                menu.smartmenus('refresh');
            });
        });
    }


    if ( $( ".search-input" ).length ) {
        //then we call ajax to re-pop with full menu
        $( ".search-input" ).each(function( index ) {
            var input = $( this  );
            var url = input.attr('data-url');

            //alert( url );

            $.ajax({
                method: "GET",
                url: url,
            })
            .done(function( result ) {
                //console.log("🚀 ~ file: app.js:98 ~ .done ~ result:", result)
                //alert( "Data Saved: " + result );

                input.attr( 'data-terms' , result );
        
            });
        });
    }

    
    //if we have a perido selector update it with ajax
    if ( $( "#date-picker-panel" ).length ) {
        //then we call ajax to re-pop with full menu
        
        var periodMenu = $( "#date-picker-panel" );
        var url = periodMenu.attr('data-url');
        var route = periodMenu.attr('data-route');
        

        //alert( url );

        $.ajax({
            method: "GET",
            url: url,
            data: { route: route }
        })
        .done(function( result ) {
            //alert( "Data Saved: " + result );

            periodMenu.html( result );
            
        });
    }


});



$(function () {
  $('[data-toggle="popover"]').popover()
})

$(function () {
    $('body').tooltip({
        selector: '[data-toggle="tooltip"]',
        'container': 'body',
    });
  //$('[data-toggle="tooltip"]').tooltip()
})

$(function() {




  $(".tablesorter").tablesorter({

  	theme : "bootstrap"
  });
});




if (window.addEventListener) {
    window.addEventListener("message", onMessage, false);        
} 
else if (window.attachEvent) {
    window.attachEvent("onmessage", onMessage, false);
}

function onMessage(event) {
    //console.log("🚀 ~ file: app.js ~ line 76 ~ onMessage ~ event", event)
    // Check sender origin to be trusted
    if (event.origin !== "https://costacheck.costa.co.uk" && event.origin !== "https://costa-compliance.myaba.co.uk" && event.origin !== "https://costa.test") return;

    var data = event.data;

    if (typeof(window[data.func]) == "function") {
        window[data.func].call(null, data.message);
    }
}

// Function to be called from iframe
function complete(message) {
    alert(message);
}

function back(message) {
    alert(message);
}

/*================PrintABA=======*/
$( document ).ready( function(){
    $('.pre-header').click( function(){
        //console.log('click');
        $( this ).parent('.pre-wrapper').find('pre').toggleClass('d-none');
      
    });
});
/**=====================AUTOCOMPLETE SEARCH============= */
$(function() {
    $('.search-autocomplete').keyup( debounce( function() {
        let input = $( this );
        let term = input.val();
        //alert( term );
        filterSearch( input , term );
        
     }, 500 )); //wait to execute for multiple keypress

     $('.search-clear').click( function(){
        $(this).addClass('d-none');
        let input = $(this).siblings('input');
        input.val('');
        filterSearch( input, '' );

     });
    //http://davidwalsh.name/javascript-debounce-function
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
    function filterSearch( input, searchString ){
        if( searchString.length > 0 ){
            input.siblings('.search-clear').removeClass( 'd-none' );
        }
        let filteredList = [];
        if( searchString.length >= 3 ){
            let searchTerms = JSON.parse( input.attr('data-terms') );
            //console.log("🚀 ~ file: app.js ~ line 222 ~ filterSearch ~ searchTerms", searchTerms)
            //console.log("🚀 ~ file: app.js ~ line 225 ~ filterSearch ~ input.attr('data-terms')", input.attr('data-terms'))


            filteredList = searchTerms.filter( (term) =>{
                let check  = term.search.toUpperCase().includes( searchString.toUpperCase() )  ;
                return check;
            });

            //console.log("🚀 ~ file: app.js ~ line 134 ~ filteredList=searchTerms.filter ~ filteredList", filteredList);
        }else{

        }

        let list = input.parents('.search-wrapper').find( '.results ul.list' );
        //empty the results list
        list.empty();

        //add filters
        filteredList.forEach(function (value) {
            list.append('<li><a href="'+value.url+'">'+value.display+'</a></li>')
        });

    }
});

/**==========FILTERS & PHASE PICKER======== */
$( document ).ready(function() {

    $('.btn-toggle-filter-panel').click( function(){
        var myBtn = $( this );
        var myPanelClass = $( this ).attr('data-panel');
        var openTxt = $( this ).attr('data-open-txt');
        var closeTxt = $( this ).attr('data-close-txt');
        
        //am I active?
        var active = false;
        var myTab = $( this ).parent('.filter-tab');
        if( $( myTab ).hasClass('active') ){
            active = true;
        }

        if( !active ){

            //close all with active
            $('.filter-panels').addClass('d-none');
            //change status of all buttons
            $('.btn-toggle-filter-panel').each( function(){
                //remove active from parent
                $( this ).parent('.filter-tab').removeClass('active');
                //change my text
                $( this ).find('.btn-txt').text( $( this ).attr('data-open-txt') ); //change text

                //hide my close
                //$( this ).find( '.fa').addClass('d-none'); 
            });


            //open me
            $('.' + myPanelClass ).hide().removeClass('d-none').slideDown();
            $( myTab ).addClass('active');
            //set text
            $( myBtn ).find('.btn-txt').text( closeTxt ); //change text
            //$( myBtn ).find( '.fa').removeClass('d-none'); //change icon
        }else{
            //close me
            $('.' + myPanelClass ).show().slideUp( 'fast' , function( ){
                $('.' + myPanelClass ).addClass('d-none');
                $( myTab ).removeClass('active');
                //set text
                $( myBtn ).find('.btn-txt').text( openTxt ); //change text
                //$( myBtn ).find( '.fa').addClass('d-none'); //change icon
            });
            
        }

        return false;

        
    });

    $('.active-filters .badge-tag').click( function(){
        var field = $( this ).attr('data-filter-field');
        var option = $( this ).attr('data-filter-option');

        var grid = $( this ).attr('data-grid');
        console.log("🚀 ~ file: app.js:322 ~ grid:", grid)

        
        if( grid == "1" ){
            console.log("$ -> option", option);
            const elements = option.split("||");
            console.log("🚀 ~ file: app.js:327 ~ $ ~ elements:", elements)
            //remove one option
            $('input:checkbox[name="f[' + field + '][' + elements[0] + '][' + elements[1] + ']"]').prop('checked', false);
            
            //return false;
        }else if( option ){
            //remove one option
            $('input:checkbox[name="f[' + field + '][' + option + ']"]').prop('checked', false);
  
        }else{
            //remove all row
            $('input:checkbox[name^="f[' + field + ']"]').prop('checked', false);
            
        }
        //then submit form
        $('#filter-form').submit();
    });
    $('.btn-clear-filters').click( function(){
        $('input:checkbox[name^="f["]').prop('checked', false);
        $('#filter-form').submit();

    });

    /**=========FILTER pre selects */
    $('.filter-preselect').click( function(){
        try {
            var btn = $( this );
            var parent = btn.closest( '.filter-wrapper' );
            var inputs = parent.find('.filter-form-checks');
            var data = JSON.parse( btn.attr( 'data-preselect' ) );
            //console.log("🚀 ~ file: app.js ~ line 325 ~ $ ~ data", data);
            
            data.forEach(function( value ) {

                inputs.find('input[data-name-lower="' + value.toLowerCase() + '"]').prop( "checked", true ) ;
                //inputs.find("input[data-name-lower='" + value.toLowerCase() + "']").prop( "checked", true ) ;
            });
        } catch( error ){
            console.error( error );
        }


        return false;
    });

    $('#date-picker-panel').on( "submit" , '#phase-picker-custom' , function( event ){

        var start_at = $('#date-picker-start-at').val();
        var end_at = $('#date-picker-end-at').val();

        if( start_at.length > 0 && end_at.length > 0 ){
            $('#date-picker-phaseVal').val( start_at + '|' + end_at );
            return true;
        }else{
            event.preventDefault();
        }
    });
});


/**
 * ============EVENTS SUB PUB================
 */
events = (function(){
    var topics = {};
    var hOP = topics.hasOwnProperty;
    return {
      subscribe: function(topic, listener) {
        // Create the topic's object if not yet created
        if(!hOP.call(topics, topic)) topics[topic] = [];
        // Add the listener to queue
        var index = topics[topic].push(listener) -1;
        // Provide handle back for removal of topic
        return {
          remove: function() {
            delete topics[topic][index];
          }
        };
      },
      publish: function(topic, info) {
        // If the topic doesn't exist, or there's no listeners in queue, just leave
        //console.log(topic);
          //console.log(info);
        if(!hOP.call(topics, topic)) return;
          
        // Cycle through topics queue, fire!
        topics[topic].forEach(function(item) {
                item(info != undefined ? info : {});
        });
      }
    };
  })();


scenarioChartSort = function( chartId, sectionId  ){
    //check if we have this section
    var chart = $( '#chart-'+chartId );
    if( chart.length == 0  ){ //exit if nothing matches selector
        return false;
    }
    var chartData = JSON.parse( $( chart ).attr( 'data-chart-data') );

    //console.log("varsubscription_chart_{{$chartId}}=events.subscribe -> chartData", chartData);
    var table = $( chart ).find('table');

    table.height( table.outerHeight() );

    //set table height to be its current height, so we dont collapse to zero height with absolute pos tr


    var sectionData = chartData.filter( function( e ){
        return sectionId == e.id;
    });
    //console.log("varsubscription_chart_{{$chartId}}=events.subscribe -> sectionData", sectionData)

    
    if( sectionData.length == 1 ){ //we have one row

        sectionData[0].rows.sort(function( a, b ){
            var score_a = ( Math.round( a.score  * 10) / 10 ) ;
            var score_b = ( Math.round( b.score  * 10) / 10 ) ;
            if (score_a < score_b) return 1;
            if (score_a > score_b) return -1;
            if ( a.cnt < b.cnt) return 1; //then on n=
            if ( a.cnt > b.cnt ) return -1;
            return 0;
        });

        var top = 0;
        //loop rows in data and set each progress width, text, n=
        sectionData[0].rows.forEach( function(  v, i ) {

            var score = ( Math.round( v.score  * 10) / 10 ) ;
            var index = v.index;
            var row = chart.find('.row_'+index);

            


            //set n=
            var hideSymbol = row.attr( 'data-hideSymbol'  ) ;
            var width = row.attr( 'data-width'  ) ;
            row.find('.cnt').text('(n='+v.cnt+')');
            //progress text
            var labelText = score;
            if(  hideSymbol != '1' ){
                labelText = score +'%';
            }
            row.find( '.label').text( labelText) ;
            row.find( '.progress-bar').animate({
                'max-width': width + '%',
                'width': width + '%',
            }, 400);
            row.find( '.progress-bar').attr( 'data-original-title' , v.title + '-' + labelText) ;
            row.attr( 'data-position' , i  ) ;
            




            row.find( '.progress-bar' ).removeClass (function (index, className) {
                return (className.match (/(^|\s)progress-bar-animate\S+/g) || []).join(' ');
            });


            row.find( '.progress-bar').addClass( 'progress-bar-animate' ) ;


            var w = row.width();
            row.css({ position: 'absolute' });

            
            row.animate({
                position: 'absolute',
                top: top + 'px',
                width: w + 'px',
        
            }, 400);
            top += row.outerHeight();


            //pu them in order
            //row_i cnt
        });


    }
}  

/**
 * =============EXPORT CHARTS===========
 */
$( document ).ready( function(){
    //ccontext menu if available
    if( $("#contextMenu").length ){
        var $contextMenu = $("#contextMenu");

        

        
        $("body").on("contextmenu", ".context-menu", function(e) {

            var contextOptions =  $( this ).attr('data-context-options') ;
            if( contextOptions ){
                contextOptions = JSON.parse( contextOptions );
                $('#contextMenu li').hide();
                contextOptions.forEach(element => {
                    $("#contextMenu li a."+element).parent('li').show();
                });
            }else{
                $('#contextMenu li').show();

            }
            
            $contextMenu.css({
                 display: "block",
                 left: e.pageX,
                 top: e.pageY,
                 zIndex: 99,
            });
            $contextMenu.caller = $( this );
           //debugger;
            return false;
       });
   
       $('html').click(function() {
            $contextMenu.hide();
       });

       $('#contextMenu a').click( function(){
            return false;
       });
       $('#contextMenu a.context-save-png').click( function(){
            $contextMenu.hide();
            var div = $contextMenu.caller;
            var chartDiv = $( div ).find('.chart');
            //console.log("🚀 ~ file: app.js ~ line 518 ~ $ ~ chartDiv", chartDiv)
            var chartId = $( chartDiv ).attr('id');
            var d3ChartDiv = d3.select( '#'+chartId );
            var svg =  d3ChartDiv.select('svg');
            var svgString = getSVGString(svg.node());
           
            //console.log("🚀 ~ file: app.js ~ line 525 ~ $ ~ svg.style(height)", svg.style("height"))
            //console.log("🚀 ~ file: app.js ~ line 525 ~ $ ~ svg.style(width)", svg.style("width"))
            svgString2Image( svgString, parseInt(svg.style("width")), parseInt(svg.style("height")), 'png', saveSvg ); // passes Blob and filesize String to the callback
            return false;
        });

        $('#contextMenu a.context-save-html-png').click( function(){

            $contextMenu.hide();
            var div = $contextMenu.caller;

            

            html2canvas($( div )[0]).then((canvas) => {
                //$('#canvas').append( canvas );

                canvas.toBlob( function(blob) {
                    var filesize = Math.round( blob.length/1024 ) + ' KB';
                    saveSvg( blob, filesize );
                });


            });

        });


    }

    //bind all the exports
    $( 'body').on( 'click' , '.btn-export-chart',  function(){
        //alert(1);
        var chartDiv = $( this ).siblings('.chart');
        var chartId = $( chartDiv ).attr('id');
        var exportType = $( this ).attr('data-export-type');
        var d3ChartDiv = d3.select( '#'+chartId );
        var svg =  d3ChartDiv.select('svg');
        var svgString = getSVGString(svg.node());
        svgString2Image( svgString, svg.style('width'), svg.style('width'), 'png', saveSvg ); // passes Blob and filesize String to the callback

        return false;
    });
});
exportSvg = function( chartId ){

}

function saveSvg( dataBlob, filesize ){
    FileSaver.saveAs( dataBlob, 'Export.png' ); // FileSaver.js function
}
function getSVGString( svgNode ) {
	svgNode.setAttribute('xlink', 'http://www.w3.org/1999/xlink');
	var cssStyleText = getCSSStyles( svgNode );
	appendCSS( cssStyleText, svgNode );

	var serializer = new XMLSerializer();
	var svgString = serializer.serializeToString(svgNode);
	svgString = svgString.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink='); // Fix root xlink without namespace
	svgString = svgString.replace(/NS\d+:href/g, 'xlink:href'); // Safari NS namespace fix

	return svgString;

	function getCSSStyles( parentElement ) {
		var selectorTextArr = [];

		// Add Parent element Id and Classes to the list
		selectorTextArr.push( '#'+parentElement.id );
		for (var c = 0; c < parentElement.classList.length; c++)
				if ( !contains('.'+parentElement.classList[c], selectorTextArr) )
					selectorTextArr.push( '.'+parentElement.classList[c] );

		// Add Children element Ids and Classes to the list
		var nodes = parentElement.getElementsByTagName("*");
		for (var i = 0; i < nodes.length; i++) {
			var id = nodes[i].id;
			if ( !contains('#'+id, selectorTextArr) )
				selectorTextArr.push( '#'+id );

			var classes = nodes[i].classList;
			for (var c = 0; c < classes.length; c++)
				if ( !contains('.'+classes[c], selectorTextArr) )
					selectorTextArr.push( '.'+classes[c] );
		}
        //console.log("🚀 ~ file: app.js ~ line 587 ~ getCSSStyles ~ selectorTextArr", selectorTextArr)

		// Extract CSS Rules
		var extractedCSSText = "";
        

		for (var i = 0; i < document.styleSheets.length; i++) {
			var s = document.styleSheets[i];
            //console.log("🚀 ~ file: app.js ~ line 551 ~ getCSSStyles ~ s", s)
			
			try {
			    if(!s.cssRules) continue;
			} catch( e ) {
		    		if(e.name !== 'SecurityError') throw e; // for Firefox
		    		continue;
		    	}

			var cssRules = s.cssRules;
            //console.log("🚀 ~ file: app.js ~ line 604 ~ getCSSStyles ~ cssRules", cssRules)
			for (var r = 0; r < cssRules.length; r++) {
                //console.log("🚀 ~ file: app.js ~ line 566 ~ getCSSStyles ~ cssRules[r]", cssRules[r])
                if ( 
                    cssRules[r].selectorText =='body' || 
                    contains( cssRules[r].selectorText, selectorTextArr ) 
                ){
					extractedCSSText += cssRules[r].cssText.replace( 'body', 'text');
                }
			}
		}
		
        //console.log("🚀 ~ file: app.js ~ line 574 ~ getCSSStyles ~ extractedCSSText", extractedCSSText)

		return extractedCSSText;

		function contains(str,arr) {
			return arr.indexOf( str ) === -1 ? false : true;
		}

	}

	function appendCSS( cssText, element ) {
		var styleElement = document.createElement("style");
		styleElement.setAttribute("type","text/css"); 
		styleElement.innerHTML = cssText;
		var refNode = element.hasChildNodes() ? element.children[0] : null;
		element.insertBefore( styleElement, refNode );
	}
}


function svgString2Image( svgString, width, height, format, callback ) {
	var format = format ? format : 'png';

	var imgsrc = 'data:image/svg+xml;base64,'+ btoa( unescape( encodeURIComponent( svgString ) ) ); // Convert SVG string to data URL

	var canvas = document.createElement("canvas");
	var context = canvas.getContext("2d");

	canvas.width = width;
	canvas.height = height;

	var image = new Image();
	image.onload = function() {
		context.clearRect ( 0, 0, width, height );
		context.drawImage(image, 0, 0, width, height);

		canvas.toBlob( function(blob) {
			var filesize = Math.round( blob.length/1024 ) + ' KB';
			if ( callback ) callback( blob, filesize );
		});

		
	};

	image.src = imgsrc;
}
